import { AGENT_IDS } from '../../../constants/agents';
import type { DigitalMaintenanceStatus } from '../../../api/conversations';

export const DIGITAL_MAINTENANCE_RESULT_COMMAND = 'Show result';
export const DIGITAL_MAINTENANCE_WAIT_MS = 60_000;

export function isDigitalMaintenanceOnly(agents: readonly string[] | undefined): boolean {
  return agents?.length === 1 && agents[0] === AGENT_IDS.DIGITAL_MAINTENANCE;
}

export function isDigitalMaintenancePendingResult(status?: DigitalMaintenanceStatus): boolean {
  return status === 'processing';
}

export function canShowDigitalMaintenanceCheckResult({
  check,
  selectedAgents,
  latestMessage,
  nowMs,
  isSending,
}: {
  check?: { eligibleAtMs: number; latestMessageId: string };
  selectedAgents?: readonly string[];
  latestMessage?: { id?: string; role: string; content: string; digital_maintenance_status?: DigitalMaintenanceStatus };
  nowMs: number;
  isSending: boolean;
}): boolean {
  return Boolean(check
    && !isSending
    && nowMs >= check.eligibleAtMs
    && isDigitalMaintenanceOnly(selectedAgents)
    && latestMessage?.role === 'assistant'
    && latestMessage.id?.replace(/-assistant$/, '') === check.latestMessageId
    && isDigitalMaintenancePendingResult(latestMessage.digital_maintenance_status));
}
